import {
  isValid2DFileType,
  isValid3DFileType,
  isValidTextFileType,
  VALID_2D_EXTENSIONS,
  VALID_3D_EXTENSIONS,
  VALID_TEXT_EXTENSIONS,
} from '@physna/supported-files';

export const INVALID_CHARS = /[\\/:*?"<>|\n\r\t]/;

export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB in bytes
export const UPLOAD_FILES_MAX_QUEUE_SIZE = 3000;

export const ERROR_MESSAGES = {
  INVALID_FILE_TYPE: 'Invalid File Type',
  INVALID_FILE_SIZE: 'Invalid File Size',
  INVALID_FILENAME: 'Invalid Filename',
  UPLOAD_FAILED: 'Upload failed',
} as const;

export const getSupportedFileExtensions = (): string => {
  const allExtensions = [...VALID_3D_EXTENSIONS, ...VALID_2D_EXTENSIONS, ...VALID_TEXT_EXTENSIONS].sort((a, b) =>
    a.localeCompare(b)
  );

  return allExtensions.join(', ');
};

export const SUPPORTED_FILE_TYPES_MESSAGE = `Supported file types: ${getSupportedFileExtensions()}`;

export const isValidFilename = (filename: string): boolean => {
  if (!filename) return false;
  return !INVALID_CHARS.test(filename);
};

export function isValidFileType(filename: string): boolean {
  return isValid3DFileType(filename) || isValid2DFileType(filename) || isValidTextFileType(filename);
}

export const validateFileSize = (file: File): boolean => {
  return file.size > 0 && file.size <= MAX_FILE_SIZE;
};

export const validateFileName = (file: File): boolean => {
  return isValidFilename(file.name);
};

export const getFileValidationError = (file: File): string => {
  if (!isValidFileType(file.name)) {
    return ERROR_MESSAGES.INVALID_FILE_TYPE;
  }

  if (!validateFileSize(file)) {
    return ERROR_MESSAGES.INVALID_FILE_SIZE;
  }

  if (!validateFileName(file)) {
    return ERROR_MESSAGES.INVALID_FILENAME;
  }

  return '';
};

export const isInvalidFileTypeError = (message: string | undefined): boolean => {
  return message === ERROR_MESSAGES.INVALID_FILE_TYPE;
};

export const isValidFile = (file: File): boolean =>
  isValidFileType(file.name) && validateFileSize(file) && validateFileName(file);
